<div class="monthly-change-plan-container">
    <span *ngIf="monthlyPlan?.selected" class="selected-icon">
        <img alt="checkmark image" class="selected-icon-image"
             src="https://www-qa1.safeway.com/content/dam/DeliverySubscription/white.svg">
    </span>
    <p class="plan-type">{{monthlyPlan?.caption}}</p>
    <div class="sub-rectangle"></div>
    <h2 class="mt-2 value"
      [innerHTML]="pricingDetailText"></h2>
    <p class="first-text">{{programDisplayData?.monthlyPlan?.taxMonthly}}</p>
    <p attr.aria-label="{{planDescriptionText}}"
        class="renews"
        [innerHTML]="planDescriptionText">
    </p>
    <button 
      *ngIf="!monthlyPlan?.selected"
      class="select pds-btn pds-btn-filled--primary pds-btn-size__medium"
      (click)="changePlanType(monthlyPlan?.code)">
        {{programDisplayData?.monthlyPlan?.selectMonthly}}
    </button>
    <button *ngIf="monthlyPlan?.selected" aria-label="Current Plan" class="current">{{programDisplayData?.annualPlan?.currentPlan}}</button>
</div>
